import {Backdrop, Box} from '@material-ui/core'
import ButtonSmall from '../Buttons/ButtonSmall'
import Styled from '../Styled'
import styles from './styles'

export const ContentBox = Styled(Box, styles.contentBox)
export const ButtonBox = Styled(Box, styles.buttonBox)
export const VideoBackdrop = Styled(Backdrop, styles.videoBackdrop)
export const CloseButton = Styled(ButtonSmall, styles.closeButton)
